import { ShopSystem } from './shopSystem';

export function requireShopSystem(): ShopSystem {
    return flRequire<ShopSystem>('shopSystem');
}
